/**
 * Where the tokens live.
 *  - access token (15 minutes): memory only
 *  - refresh token (30 days, single use): localStorage, so a reload keeps you signed in
 * Trade-off: localStorage is readable by any script on the page, so the site ships a strict
 * Content-Security-Policy (no inline or third-party scripts except the payment and video SDKs).
 * Moving the refresh token to an httpOnly cookie is the next hardening step and needs a backend change.
 */
import { local } from './storage.js';

const REFRESH_KEY = 'vc.refresh';
let access = null;

export const tokens = {
  get access() {
    return access;
  },
  get refresh() {
    return local.get(REFRESH_KEY);
  },
  set(pair) {
    access = pair.access_token ?? null;
    if (pair.refresh_token) local.set(REFRESH_KEY, pair.refresh_token);
  },
  clear() {
    access = null;
    local.remove(REFRESH_KEY);
  },
};
